// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ModifyPortCall\CancelPortCallRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// CancelPortCallRequestData is the class that CancelPortCallRequest serializes to/from
export interface CancelPortCallRequestData {
	
	
    Remarks : string | null;
}

// CancelPortCallRequestOptions is the class which may be passed to the CancelPortCallRequest constructor to define optional initial data values
export interface CancelPortCallRequestOptions {
	
	
    Remarks? : string | null;
}

export class CancelPortCallRequest {
	
	
    public Remarks : DataSignal<string | null>;

    constructor();
    constructor(data : CancelPortCallRequestOptions);
    constructor(data: CancelPortCallRequestOptions | null = null) {
	    
	    
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
    }

    static key(obj : CancelPortCallRequest) {
        return ;
    }
    
    static dataKey(obj : CancelPortCallRequestOptions) {
        return ;
    }

    static update(obj : CancelPortCallRequest, data : CancelPortCallRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CancelPortCallRequest.ts